import React, { useState, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './index.module.scss';
import cn from 'classnames';
import { getObjectValue } from '@utility/utills';
import { LABEL, CUSTOM_MESSAGES } from '../../veriables';
import Modal from '@components/common/Modal';
import filter from 'lodash/filter';
import find from 'lodash/find';
import reverse from 'lodash/reverse';
import Button from '@components/common/LongPressButton';

const renderModifier = (modifiersObj, node) => (
  <ul className={cn('pl-2 m-0 fs-12')}>
    {modifiersObj.map((modifier) => {
      return (
        <li key={modifier.modifierId}>
          {modifier.quantity > 1 && (<span className="badge badge-warning ml-1 va-tt">{modifier.quantity} &times;</span>)}
          {modifier.modifierName}
          {node === 0 && modifier.price ? (<small className="text-muted od-text-muted ml-1">{LABEL().CURRENCY_SYMBOL}{modifier.price.toFixed(2)}</small>) : ''}
          {(modifier.note || modifier.comment) && <div className="pl-2">{modifier.note || modifier.comment}</div>}
          {modifier.modifiers && modifier.modifiers.length > 0 && (
            renderModifier(modifier.modifiers, node)
          )}
        </li>
      );
    })}
  </ul>
);

const displayColor = (isSelected, isProcessing = false) => {
  if (isProcessing) {
    return `border background-primary od-check-unsent-background roundedSm od-container-card-border border-color-primary roundedSm ${styles.processingItem}`;
  }
  if (isSelected) {
    return 'border border-color-secondary  od-container-card-background background-secondary roundedSm';
  }
  return 'border background-primary od-app-background-color roundedSm od-container-card-border border-color-primary roundedSm';
};

const ItemsList = ({
  checkList, node, SendBtmBtn, position,
  seatOrDiscountArray,
  setCardIndex, cardIndex,
  isMultiSelectItem = false,
  setItemsAssociated = () => { },
  setPendingItems = () => { },
  setCurrentNode, cardBtns,
  auth,
  checkItemPresent
}) => {
  const [currentModifiers, setCurrentModifiers] = useState([]);
  const checks = (node === 0 && position !== -1) ? checkList?.filter((check) => check.checkOrderItemId < 0 || check.checkOrderItemId !== 0) : checkList;
  if (!(seatOrDiscountArray && seatOrDiscountArray?.length > 0) && (checks?.length === 0 || !checks)) {
    return <div className="d-flex justify-content-center align-items-center h-100 fs-14 fw-600 pt-1 overflowY od-text-primary text-primary" style={{ maxheight: '80%' }}>{CUSTOM_MESSAGES().NO_ITEM_FOUND}</div>;
  }

  const handleCartSelection = (item, index) => {
    if (node === 0) {
      setItemsAssociated(checks.map((e) => { return { ...e, isCheck: false }; }));
    } else {
      setPendingItems(checks.map((e) => { return { ...e, isCheck: false }; }));
    }
    if (!(seatOrDiscountArray && seatOrDiscountArray.length > 0)) {
      if (cardIndex.indexOf(`${node}${index}${item.id}`) === -1) {
        setCardIndex(`${node}${index}${item.id}`);
      } else {
        setCardIndex([]);
      }
    } else {
      setCardIndex(`${node}${index}${item.id}`);
    }
  };

  const handleShowModifiers = (subnode, id) => {
    setCurrentNode([subnode]);
    if (currentModifiers.indexOf(`${subnode}-${id}`) === -1) {
      setCurrentModifiers(currentModifiers.concat(`${subnode}-${id}`));
    } else {
      setCurrentModifiers(currentModifiers.filter((x) => x !== `${subnode}-${id}`));
    }
  };

  const handleItems = (data, isSelect) => {
    setCurrentNode([node]);
    setCardIndex([]);
    if (node === 0) {
      const foundIndex = checks.findIndex((x) => x.id === data.id);
      checks[foundIndex] = { ...data, isCheck: isSelect };
      setItemsAssociated(checks);
    }
    if (node === 1) {
      const foundIndex = checks.findIndex((x) => { return data.isProcessing ? x.internalId === data.internalId : x.id === data.id; });
      checks[foundIndex] = { ...data, isCheck: isSelect };
      setPendingItems(checks);
    }
  };
  return checks && checks.length > 0 && checks.map((item, index) => {
    return (
      <div key={item.id} role="presentation">
        <div className={cn('col-12 p-0')}>
          <div className="p-1">
            <div className={cn('p-1', displayColor(item?.isProcessing, cardIndex.includes(`${node}${index}${item.id}`)))}>
              <div className="col-12 p-0 row mx-0 justify-content-center align-items-center">
                {isMultiSelectItem && (
                  <div className="col-1 p-0">
                    <input
                      type="checkbox"
                      id={item.id}
                      onChange={() => { }}
                      className={cn(styles.checkbox)}
                      onClick={(e) => handleItems(item, e.target.checked)}
                      checked={item.isCheck || false}

                    />
                  </div>
                )}
                <div className={cn('px-2 fs-12 row mx-0 od-text-primary align-items-center', isMultiSelectItem ? 'col-11' : 'col-12')} role="presentation" onClick={() => { return handleCartSelection(item, index); }}>
                  <div className={cn('text-left fs-12 fw-500 p-0 col-6', styles.breakWord)}>{item.menuItemName}</div>
                  <div
                    className="p-0 od-text-primary col-1 text-right text-primary"
                    role="presentation"
                    onClick={(e) => {
                      if (item.modifiers && item.modifiers.length > 0) {
                        e.stopPropagation();
                        handleShowModifiers(node, item.id);
                      }
                    }}
                  >
                    {item.modifiers && item.modifiers.length > 0 && (
                      currentModifiers.includes(`${node}-${item.id}`) ? (
                        <i
                          className={cn('fa fa-angle-double-up fs-12')}
                          aria-hidden="true"
                        />
                      ) : (
                        <i
                          className={cn('fa fa-angle-double-down fs-12')}
                          aria-hidden="true"
                        />
                      )
                    )}
                  </div>
                  <div className={cn(node === 0 && 'col-1 text-right', node === 1 && !auth.serverAppFeatures.displayPrice ? 'col-4 text-right' : 'col-1 text-right', 'fw-500 p-0')}>{item.seats && item.seats.length > 0 && item.seats[0].splitValue > 1 && position !== -1 && item.quantity ? `${item.quantity}/${item.seats[0].splitValue}` : item.quantity}</div>
                  {node === 0 && (<div className="col-4 p-0 text-right fw-500">{LABEL().CURRENCY_SYMBOL}{item.price.toFixed(2)}</div>)}
                  {node === 1 && auth.serverAppFeatures.displayPrice && Number(item.price) > 0 && (<div className="col-4 p-0 text-right fw-500">{LABEL().CURRENCY_SYMBOL}{Number(item.price).toFixed(2)}</div>)}
                </div>
              </div>
              <div className="col-11 offset-1 od-text-primary px-2" role="presentation" onClick={() => { handleCartSelection(item, index); }}>
                {(item.modifiers && item.modifiers.length > 0) && currentModifiers.includes(`${node}-${item.id}`) && renderModifier(item.modifiers, node)}
                {(cardIndex.includes(`${node}${index}${item.id}`) || currentModifiers.includes(`${node}-${item.id}`)) && (item.note || item.comment) && <div className="col-12 text-left pl-2 px-0">{item.note || item.comment}</div>}
              </div>
              {cardBtns && cardBtns.length > 0 && cardIndex.includes(`${node}${index}${item.id}`) && (
                <div className="row justify-content-center m-0 py-1">
                  {cardBtns?.map((btn) => {
                    const isEditDisabledForPack = btn.key === 'edit' && isPackItem(item);
                    return btn?.show && (
                      <div key={btn.key} className="p-1 col-6">
                        <Button
                          onClick={() => { if (!isEditDisabledForPack) btn.click(btn.key === 'edit' ? item : [item]); }}
                          onLongPress={() => ['send'].includes(btn.key) && btn.longPress([item])}
                          className={cn('btn text-center fs-14 btn20 btn-ripple roundedSm fw-700')}
                          disabled={isEditDisabledForPack}
                          style={isEditDisabledForPack ? { cursor: 'not-allowed', background: 'rgb(177,177,177)' } : {}}
                        >
                          {['send'].includes(btn.key) ? <u>{btn.name}</u> : btn.name}
                        </Button>
                      </div>
                    );
                  })}
                </div>
              )}
              {SendBtmBtn && SendBtmBtn.length > 0 && cardIndex.includes(`${node}${index}${item.id}`) && (
                <div className="row m-0 py-1">
                  {SendBtmBtn?.map((btn) => {
                    return btn?.show && (
                      <div key={btn.key} className="p-1 col-6">
                        <button type="button" onClick={() => { btn.click([item]); }} className={cn('btn btn20 w-100 text-center fs-14 btn-primary btn-ripple roundedSm od-btn-primary fw-700')} disabled={btn.key === 'repeat' ? !checkItemPresent([item], 'sent') : false}>{btn.name}</button>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  });
};

ItemsList.propTypes = {
  checkList: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
  node: PropTypes.number.isRequired,
  SendBtmBtn: PropTypes.array,
  position: PropTypes.number,
  seatOrDiscountArray: PropTypes.array,
  setCardIndex: PropTypes.func,
  cardIndex: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  isMultiSelectItem: PropTypes.bool,
  setItemsAssociated: PropTypes.func,
  setPendingItems: PropTypes.func,
  setCurrentNode: PropTypes.func,
  cardBtns: PropTypes.array,
  auth: PropTypes.object,
  checkItemPresent: PropTypes.func,
  currentNode: PropTypes.array,
};

ItemsList.defaultProps = {
  checkList: [],
  SendBtmBtn: [],
  position: undefined,
  seatOrDiscountArray: undefined,
  setCardIndex: () => {},
  cardIndex: [],
  isMultiSelectItem: false,
  setItemsAssociated: () => {},
  setPendingItems: () => {},
  setCurrentNode: () => {},
  cardBtns: [],
  auth: {},
  checkItemPresent: () => {},
  currentNode: [],
};

const SingleItem = (props) => {
  const [currentNode, setCurrentNode] = useState([1]);
  const [cardIndex, setCardIndex] = useState([]);
  const [itemsAssociated, setItemsAssociated] = useState([]);
  const [pendingItems, setPendingItems] = useState([]);
  const [activeTab, setActiveTab] = useState('pending');
  const cart = props.item;
  const [isOpen, setOpen] = useState(false);
  const isWalkUp = getObjectValue(() => props.seat && (props.seat.sourceType === 7), false);
  const isDefaultMode = getObjectValue(() => (!isWalkUp && (!props.deviceInfo.deviceGroup || [0].includes(props.deviceInfo.deviceGroup.startMode))), false);
  // const isSpeedOrderMode = getObjectValue(() => [1].includes(props.deviceInfo.deviceGroup.startMode), false);

  const handleSelectAll = (node, isSelectAll) => {
    setCardIndex([]);
    if (node === 0) {
      setItemsAssociated(itemsAssociated.map((e) => { return { ...e, isCheck: isSelectAll }; }));
    } else {
      setPendingItems(pendingItems?.map((e) => { return { ...e, isCheck: isSelectAll }; }));
    }
  };

  useLayoutEffect(() => {
    let sentItems = [];
    if (props.position.number !== -1) {
      sentItems = props?.seat?.items?.reduce((a, v) => {
        const seatItem = v?.seats.find((e) => e.seatId === props.position.id);
        const orderItem = props?.seat?.orders?.[0]?.items?.find((d) => d.checkItemId === v.id);
        const modifiers = orderItem && JSON.parse(orderItem.orderJson).modifierJson && JSON.parse(JSON.parse(orderItem.orderJson).modifierJson).hasLinkedMenuItem ? JSON.parse(JSON.parse(orderItem.orderJson).modifierJson).modifiers : v.modifiers;
        if (seatItem && orderItem && !(JSON.parse(orderItem.orderJson).modifierJson && JSON.parse(JSON.parse(orderItem.orderJson).modifierJson).isLinked)) {
          a.push({
            ...v,
            price: seatItem.splitAmount,
            modifiers
          });
        } else if (seatItem && !orderItem) {
          a.push({
            ...v,
            modifiers
          });
        }
        return a;
      }, []);
    } else {
      sentItems = props?.seat?.Items?.reduce((a, v) => {
        const orderItem = props?.seat?.orders?.[0]?.items?.find((d) => d.checkItemId === v.id);
        const modifiers = orderItem && getObjectValue(() => JSON.parse(JSON.parse(orderItem.orderJson).modifierJson).hasLinkedMenuItem, false) ? JSON.parse(JSON.parse(orderItem.orderJson).modifierJson).modifiers : v.modifiers;
        if (orderItem && getObjectValue(() => !JSON.parse(JSON.parse(orderItem.orderJson).modifierJson).isLinked, false)) {
          a.push({
            ...v,
            modifiers
          });
        }
        return a;
      }, []);
    }
    const pendingItemsList = props.cart.length > 0 && getObjectValue(() => props.cart, []).filter((e) => e.pending && !e.isLinked).reduce((a, v) => {
      if (props.position.number !== -1 && getObjectValue(() => v.seatIds && v.seatIds.length > 0 && v.seatIds.some((e) => e === props.position.seatId), false)) {
        a.push(v);
      } else if (props.position.number === -1) {
        a.push(v);
      }
      return a;
    }, []);
    setItemsAssociated(sentItems);
    const reversedItems = pendingItemsList && reverse(pendingItemsList);
    if (isDefaultMode) {
      setActiveTab(getObjectValue(() => reversedItems && reversedItems.length > 0 > 0, false) ? 'pending' : 'sent');
    } else {
      setActiveTab('pending');
    }
    setPendingItems(reversedItems || []);
    const requiredCardIndex = reversedItems?.reduce((a, v, i) => {
      if (props.highlightedCartItems.some((d) => d.id === v.id)) {
        a.push(`1${i}${v.id}`);
      }
      return a;
    }, []);
    setCardIndex(requiredCardIndex || []);
  }, [props.position.number, props.cart, props.seat]);

  let serviceChargeItems = [];
  if (props.position.number !== -1) {
    serviceChargeItems = filter(props.seat.serviceCharges, (itm) => itm.seats && find(itm.seats, (seatSplit) => (seatSplit.seatId === props.position.id)));
    for (let i = 0; i < serviceChargeItems.length; i += 1) {
      const singleItm = find(serviceChargeItems[i].seats, (singleItem) => singleItem.seatId === props.position.id);
      serviceChargeItems[i] = {
        ...serviceChargeItems[i],
        price: singleItm.splitAmount,
        menuItemName: serviceChargeItems[i].serviceChargeName
      };
    }
  } else {
    const temp = (props.seat?.serviceCharges?.length) || 0;
    for (let i = 0; i < temp; i += 1) {
      serviceChargeItems.push({
        ...props.seat.serviceCharges[i],
        price: props.seat.serviceCharges[i].price,
        menuItemName: props.seat.serviceCharges[i].serviceChargeName
      });
    }
  }

  let discountItems = [];
  if (props.position.number !== -1) {
    discountItems = filter(props.seat.discounts, (itm) => itm.seats && find(itm.seats, (seatSplit) => (seatSplit.seatId === props.position.id)));
    for (let i = 0; i < discountItems.length; i += 1) {
      const singleItm = find(discountItems[i].seats, (singleItem) => singleItem.seatId === props.position.id);
      discountItems[i] = {
        ...discountItems[i],
        price: singleItm.splitAmount,
        menuItemName: discountItems[i].discountName
      };
    }
  } else {
    const temp = (props.seat?.discounts?.length) || 0;
    for (let i = 0; i < temp; i += 1) {
      discountItems.push({
        ...props.seat.discounts[i],
        price: props.seat.discounts[i].value,
        menuItemName: props.seat.discounts[i].discountName
      });
    }
  }

  const isPackItem = (item) => {
    return props.menuItemsHashTable?.[item?.menuItemId]?.pack || props.menuItemsHashTable?.[item?.menuItemId]?.cardType === 1;
  };

  const cardBtns = [
    {
      name: LABEL().EDIT,
      key: 'edit',
      click: (data) => {
        if (isPackItem(data)) return;
        props.onModifyItem(data, 'edit');
      },
      // show: (isDefaultMode || isSpeedOrderMode || isWalkUp),
      show: (isDefaultMode || isWalkUp),
    },
    {
      name: LABEL().MOVE,
      key: 'move',
      click: (data) => props.move(data, 'unsent'),
      show: isDefaultMode,
    },
    {
      name: LABEL().DELETE,
      key: 'delete',
      click: (data) => props.onRemoveItemFromCart(data, 'deleteSingle'),
      // show: (isDefaultMode || isSpeedOrderMode || isWalkUp),
      show: (isDefaultMode || isWalkUp),
    },
    {
      name: LABEL().SEND,
      key: 'send',
      click: (data) => props.sendSingle(data, 'sendSingle'),
      longPress: (data) => props.handleLongPress(data, 'sendSingle'),
      show: isDefaultMode,
    },
    {
      name: LABEL().REPEAT,
      click: (data) => props.handleRepeat(data, 'unsent'),
      // show: (isDefaultMode || isSpeedOrderMode || isWalkUp),
      show: (isDefaultMode || isWalkUp),
    }
  ];

  const SendBtmBtn = [
    {
      name: LABEL().MOVE, key: 'move', click: (data) => props.move(data, 'sent'), show: true
    },
    {
      name: LABEL().REPEAT, key: 'repeat', click: (data) => props.handleRepeat(data, 'sent'), show: true
    },
    {
      name: LABEL().VOID, key: 'void', click: (data) => { props.setVoidItemData(data); props.handleMangerAuthentication(); }, show: props.auth.nonIntegratedPos
    }
  ];

  const SentDiscountBtn = [
    {
      name: LABEL().MOVE, key: 'move', click: (data) => props.move(data, 'discount'), show: true
    },
  ];

  const SentServiceBtn = [
    {
      name: LABEL().MOVE, key: 'move', click: (data) => props.move(data, 'service'), show: true
    },
  ];

  const BottomBtn = pendingItems && pendingItems.filter((e) => e.isCheck).length === 0 ? [
    {
      name: LABEL().DELETE_ALL,
      key: 'deleteAll',
      click: () => props.deleteAll('delete'),
      // show: (isDefaultMode || isSpeedOrderMode || isWalkUp),
      show: (isDefaultMode || isWalkUp),
    },
    {
      name: LABEL().SEND_ALL,
      key: 'sendAll',
      click: () => props.deleteAll('send'),
      longPress: (data) => props.handleLongPress(data, 'sendAll'),
      show: isDefaultMode
    }
  ] : [
    {
      name: LABEL().MOVE,
      key: 'move',
      click: (data) => props.move(data, 'unsent'),
      show: isDefaultMode
    },
    {
      name: LABEL().REPEAT,
      key: 'repeat',
      click: (data) => props.handleRepeat(data, 'unsent'),
      // show: (isDefaultMode || isSpeedOrderMode || isWalkUp),
      show: (isDefaultMode || isWalkUp),
    },
    {
      name: LABEL().DELETE,
      key: 'delete',
      click: (data) => props.onRemoveItemFromCart(data, 'deleteSelect'),
      // show: (isDefaultMode || isSpeedOrderMode || isWalkUp),
      show: (isDefaultMode || isWalkUp),
    },
    {
      name: LABEL().SEND,
      key: 'send',
      click: (data) => props.sendSingle(data, 'sendSelect'),
      longPress: (data) => props.handleLongPress(data, 'sendSelect'),
      show: isDefaultMode
    },
  ];
  const sentItemsAnchoredBtns = itemsAssociated && itemsAssociated.filter((e) => e.isCheck).length > 0 ? [
    {
      name: LABEL().MOVE, key: 'move', click: (data) => props.move(data, 'sent'), show: true
    },
    {
      name: LABEL().REPEAT, key: 'repeat', click: (data) => props.handleRepeat(data, 'sent'), show: true
    },
    {
      name: LABEL().VOID, key: 'void', click: (data) => { props.setVoidItemData(data); props.handleMangerAuthentication(); }, show: props.auth.nonIntegratedPos
    }
  ] : [];

  const cartTypes = [
    {
      key: 'sent',
      label: LABEL().SENT,
      refKey: 'items',
      show: isDefaultMode
    },
    {
      key: 'pending',
      label: LABEL().PENDING,
      refKey: 'pendingItems',
      // show: (isDefaultMode || isSpeedOrderMode || isWalkUp)
      show: (isDefaultMode || isWalkUp),
    }
  ];

  const displayStyles = (items, type) => {
    switch (type) {
      case 'sent': return items && items.filter((e) => e.isCheck).length > 0 ? 'h-80' : 'h-94';
      case 'pending': return isDefaultMode && items && items.filter((e) => e.isCheck).length > 0 ? 'h-82' : 'h-89';
      default: return 'h-95';
    }
  };

  const showCheckbox = (ref) => {
    if (ref === 'items') {
      return (
        itemsAssociated && itemsAssociated.length > 0 && (
          <div className="col-2 px-1 h-100 d-flex justify-content-center align-items-center">
            <input
              type="checkbox"
              id="sent"
              onChange={() => { }}
              className={cn(styles.checkbox)}
              onClick={(e) => { e.stopPropagation(); handleSelectAll(0, e.target.checked); }}
              checked={itemsAssociated.filter((e) => e.isCheck).length === itemsAssociated.length || false}
            />
          </div>
        )
      );
    }
    if (ref === 'pendingItems') {
      return (
        pendingItems && pendingItems.length > 0 && (
          <div className="col-2 px-1 h-100 d-flex justify-content-center align-items-center">
            <input
              type="checkbox"
              id="pending"
              onChange={() => { }}
              className={cn(styles.checkbox)}
              onClick={(e) => handleSelectAll(1, e.target.checked)}
              checked={pendingItems.filter((e) => e.isCheck).length === pendingItems.length || false}
            />
          </div>
        )
      );
    }
    return null;
  };

  return (
    <>
      <div className="border-bottom border-color-secondary border-primary col-12 h-5 row mx-0 px-0 justify-content-center">
        {cartTypes?.map(({
          key, label, refKey,
          show
        }) => {
          return show && (
            <div
              id={key}
              key={key}
              role="presentation"
              className={cn('h-100 col row mx-0 justify-content-center p-0 fw-600', activeTab === key ? 'od-text-primary text-primary od-container-card-background background-secondary' : 'opacity-50 od-text-secondary text-secondary od-app-background-color background-primary')}
              onClick={() => {
                setActiveTab(key);
                handleSelectAll(activeTab === 'sent' ? 1 : 0, false);
              }}
            >
              {showCheckbox(refKey)}
              <div className={cn('col w-600 fs-12 p-0 text-center')}>
                {label} {key === 'sent' ? `(${itemsAssociated?.length || 0})` : `(${pendingItems?.length || 0})`}
              </div>
            </div>
          );
        })}
      </div>
      <>
        <div className={cn(displayStyles(itemsAssociated, 'sent'), activeTab === 'sent' ? 'overflowY pt-1 pb-3' : 'd-none')}>
          <ItemsList
            checkList={itemsAssociated?.filter((value) => Object.keys(value).length > 0)}
            node={0}
            cardBtns={[]}
            SendBtmBtn={SendBtmBtn}
            position={props.position.number}
            setCardIndex={setCardIndex}
            cardIndex={cardIndex}
            setItemsAssociated={setItemsAssociated}
            setPendingItems={setPendingItems}
            setCurrentNode={setCurrentNode}
            currentNode={currentNode}
            isMultiSelectItem
            auth={props.auth}
            checkItemPresent={props.checkItemPresent}
          />
          {props.seat.serviceCharges && props.seat.serviceCharges.length > 0 && (
            <ItemsList
              checkList={serviceChargeItems.filter((value) => Object.keys(value).length > 0)}
              node={0}
              cardBtns={[]}
              SendBtmBtn={SentServiceBtn}
              position={props.position.number}
              seatOrDiscountArray={props.seat.serviceCharges}
              setCardIndex={setCardIndex}
              currentNode={currentNode}
              cardIndex={cardIndex}
              auth={props.auth}
            />
          )}
          {props.seat.discounts && props.seat.discounts.length > 0 && (
            <ItemsList
              checkList={discountItems.filter((value) => Object.keys(value).length > 0)}
              node={0}
              cardBtns={[]}
              SendBtmBtn={SentDiscountBtn}
              position={props.position.number}
              seatOrDiscountArray={props.seat.discounts}
              setCardIndex={setCardIndex}
              cardIndex={cardIndex}
              currentNode={currentNode}
              auth={props.auth}
            />
          )}
        </div>
        {activeTab === 'sent' && itemsAssociated && itemsAssociated.length > 0 && (
          <div className="col-12 p-0 row mx-0">
            {sentItemsAnchoredBtns.map((bnt) => {
              return bnt.show && (
                  <div key={bnt.name} className="col-6 py-1 px-1">
                    <button type="button" onClick={() => bnt.click(itemsAssociated.filter((e) => e.isCheck))} className="btn w-100 position-relative text-center fs-14 btn20 roundedSm btn-primary btn-ripple od-btn-primary color-white d-flex align-items-center justify-content-center" disabled={bnt.key === 'repeat' ? !props.checkItemPresent(itemsAssociated.filter((e) => e.isCheck), 'sent') : false}>
                      <span className={styles.paddingRight}>{bnt.name}</span>
                      {itemsAssociated && itemsAssociated.filter((e) => e.isCheck).length > 0 ? <input type="checkbox" checked /> : ''}
                    </button>
                  </div>
              );
            })}
          </div>
        )}
      </>
      <>
        <div className={cn(displayStyles(pendingItems, 'pending'), activeTab === 'pending' ? 'overflowY pt-1 pb-3' : 'd-none')}>
          <ItemsList
            checkList={pendingItems && pendingItems.length > 0 && pendingItems.filter((value) => Object.keys(value).length > 0)}
            node={1}
            cardBtns={cardBtns}
            SendBtmBtn={[]}
            position={props.position.number}
            seatOrDiscountArray={props.seat.discounts}
            setCardIndex={setCardIndex}
            cardIndex={cardIndex}
            setItemsAssociated={setItemsAssociated}
            setPendingItems={setPendingItems}
            setCurrentNode={setCurrentNode}
            currentNode={currentNode}
            isMultiSelectItem
            auth={props.auth}
          />
        </div>
        {activeTab === 'pending' && pendingItems && pendingItems.length > 0 && (
          <div className="col-12 p-0 row mx-0 justify-content-center">
            {BottomBtn.map((btn) => {
              return btn.show && (               
                  <div key={btn.name} className="col-6 py-1 px-1">
                    <Button
                      onClick={() => btn.click(pendingItems.filter((e) => e.isCheck))}
                      onLongPress={() => ['sendAll', 'send'].includes(btn.key) && btn.longPress(pendingItems.filter((e) => e.isCheck))}
                      className="btn text-center fs-14 btn20 roundedSm btn-primary btn-ripple od-btn-primary color-white d-flex align-items-center justify-content-center"
                    >
                      <span className="px-2">{['sendAll', 'send'].includes(btn.key) ? <u>{btn.name}</u> : btn.name}</span>
                      {pendingItems && pendingItems.filter((e) => e.isCheck).length === 0 ? '' : <input type="checkbox" checked />}
                    </Button>
                  </div>                
              );
            })}
          </div>
        )}
      </>
      <Modal isOpen={isOpen}>
        <div className="mb-0">
          <div className="p-10">
            <div className="col text-right btn-as-text color-secondary">
              <div className="icon-od icon-od-close" role="presentation" onClick={() => { setOpen(false); }} />
            </div>
          </div>
          <div className="mx-0 justify-content-center align-items-center text-center">
            <div className="fs-18 fw-600 text-center mt-20">
              <div>
                {CUSTOM_MESSAGES().DELETE_ITEM_CONFIRMATION}
              </div>
            </div>
            <div className="row mt-20 mb-20 justify-content-center align-items-center text-center">
              <button className="btn mr-20 btn btn-secondary od-btn-secondary col-4" type="button" onClick={() => { setOpen(false); }}>
                {LABEL().NO}
              </button>
              <button className="btn ml-20 btn btn-primary btn-ripple od-btn-primary col-4" type="button" onClick={() => { setOpen(false); props.onRemoveItemFromCart(cart.internalId); }}>
                {LABEL().YES}
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

SingleItem.propTypes = {
  item: PropTypes.object,
  seat: PropTypes.object,
  deviceInfo: PropTypes.object,
  position: PropTypes.object,
  cart: PropTypes.array,
  highlightedCartItems: PropTypes.array,
  onModifyItem: PropTypes.func,
  move: PropTypes.func,
  onRemoveItemFromCart: PropTypes.func,
  sendSingle: PropTypes.func,
  handleLongPress: PropTypes.func,
  handleRepeat: PropTypes.func,
  setVoidItemData: PropTypes.func,
  handleMangerAuthentication: PropTypes.func,
  auth: PropTypes.object,
  deleteAll: PropTypes.func,
  checkItemPresent: PropTypes.func,
};

SingleItem.defaultProps = {
  item: {},
  seat: {},
  deviceInfo: {},
  position: {},
  cart: [],
  highlightedCartItems: [],
  onModifyItem: () => {},
  move: () => {},
  onRemoveItemFromCart: () => {},
  sendSingle: () => {},
  handleLongPress: () => {},
  handleRepeat: () => {},
  setVoidItemData: () => {},
  handleMangerAuthentication: () => {},
  auth: {},
  deleteAll: () => {},
  checkItemPresent: () => {},
};

const Cart = (props) => {
  const { cart } = props;
  const cartCard = (item, position, check) => {
    const [currentNode, setCurrentNode] = useState([0, 1]);
    const [cardIndex, setCardIndex] = useState([]);
    const onCollapse = (node) => {
      if (currentNode.indexOf(node) === -1) {
        setCurrentNode(currentNode.concat(node));
      } else {
        setCurrentNode(currentNode.filter((x) => x !== node));
      }
    };
    let itemsAssociated;
    if (props.position.number !== -1) {
      itemsAssociated = filter(check.items, (itm) => itm.seats && find(itm.seats, (seatSplit) => (seatSplit.seatId === position.id)));
      for (let i = 0; i < itemsAssociated.length; i += 1) {
        const singleItm = find(itemsAssociated[i].seats, (singleItem) => singleItem.seatId === props.position.id);
        itemsAssociated[i] = {
          ...itemsAssociated[i],
          price: singleItm.splitAmount,
        };
      }
    } else {
      itemsAssociated = check.Items;
    }

    let serviceChargeItems = [];
    if (props.position.number !== -1) {
      serviceChargeItems = filter(props.seat.serviceCharges, (itm) => itm.seats && find(itm.seats, (seatSplit) => (seatSplit.seatId === props.position.id)));
      for (let i = 0; i < serviceChargeItems.length; i += 1) {
        const singleItm = find(serviceChargeItems[i].seats, (singleItem) => singleItem.seatId === props.position.id);
        serviceChargeItems[i] = {
          ...serviceChargeItems[i],
          price: singleItm.splitAmount,
          menuItemName: serviceChargeItems[i].serviceChargeName
        };
      }
    } else {
      const temp = (props.seat?.serviceCharges?.length) || 0;
      for (let i = 0; i < temp; i += 1) {
        serviceChargeItems.push({
          ...props.seat.serviceCharges[i],
          price: props.seat.serviceCharges[i].price,
          menuItemName: props.seat.serviceCharges[i].serviceChargeName
        });
      }
    }

    let discountItems = [];
    if (props.position.number !== -1) {
      discountItems = filter(props.seat.discounts, (itm) => itm.seats && find(itm.seats, (seatSplit) => (seatSplit.seatId === props.position.id)));
      for (let i = 0; i < discountItems.length; i += 1) {
        const singleItm = find(discountItems[i].seats, (singleItem) => singleItem.seatId === props.position.id);
        discountItems[i] = {
          ...discountItems[i],
          price: singleItm.splitAmount,
          menuItemName: discountItems[i].discountName
        };
      }
    } else {
      const temp = (props.seat?.discounts?.length) || 0;
      for (let i = 0; i < temp; i += 1) {
        discountItems.push({
          ...props.seat.discounts[i],
          price: props.seat.discounts[i].value,
          menuItemName: props.seat.discounts[i].discountName
        });
      }
    }

    const pendingItems = item && item.length > 0 && getObjectValue(() => item, []).filter((e) => e.pending).map((d) => {
      let data = [];
      if (props.position.number !== -1) {
        data = d.seatIds[0] === props.position.seatId && d;
      } else {
        data = d;
      }
      return data;
    });
    return (
      <div className="overflowY" style={{ height: '94%' }}>
        <div className="border roundedSm my-2 od-container-card-border od-container-card-border od-container-card-border border-color-primary roundedSm od-border-primary">
          <div className={cn('d-flex od-container-card-border border-color-primary roundedSm m-0', currentNode.includes(0) ? 'border-bottom ' : '')}>
            <div className="col-10 fw-600 pt-1 od-text-primary">
              {LABEL().SENT}
            </div>
            <div className="col-2 pt-1 od-text-primary text-right" role="presentation" onClick={() => onCollapse(0)}>
              <i className={currentNode.includes(0) ? 'fa fa-angle-up' : 'fa fa-angle-down'} aria-hidden="true" />
            </div>
          </div>
          <div className={currentNode.includes(0) ? 'overflowY h-100' : 'd-none'} style={{ maxHeight: '87%' }}>
            <ItemsList
              checkList={itemsAssociated.filter((value) => Object.keys(value).length > 0)}
              node={0}
              cardBtns={[]}
              SendBtmBtn={[]}
              position={props.position.number}
              setCardIndex={setCardIndex}
              cardIndex={cardIndex}
            />
            {props.seat.serviceCharges && props.seat.serviceCharges.length > 0 && (
              <ItemsList
                checkList={serviceChargeItems.filter((value) => Object.keys(value).length > 0)}
                node={0}
                cardBtns={[]}
                SendBtmBtn={[]}
                position={props.position.number}
                seatOrDiscountArray={props.seat.serviceCharges}
                setCardIndex={setCardIndex}
                cardIndex={cardIndex}
              />
            )}
            {props.seat.discounts && props.seat.discounts.length > 0 && (
              <ItemsList
                checkList={discountItems.filter((value) => Object.keys(value).length > 0)}
                node={0}
                cardBtns={[]}
                SendBtmBtn={[]}
                position={props.position.number}
                seatOrDiscountArray={props.seat.discounts}
                setCardIndex={setCardIndex}
                cardIndex={cardIndex}
              />
            )}
          </div>
        </div>
        <div className="border roundedSm my-2 od-container-card-border border-color-primary roundedSm od-border-primary">
          <div className={cn('d-flex od-container-card-border border-color-primary roundedSm m-0', currentNode.includes(1) ? 'border-bottom ' : '')}>
            <div className="col-10 fw-600 pt-1 od-text-primary">
              {LABEL().PENDING}
            </div>
            <div className="col-2 pt-1 od-text-primary text-right" role="presentation" onClick={() => onCollapse(1)}>
              <i className={currentNode.includes(1) ? 'fa fa-angle-up' : 'fa fa-angle-down'} aria-hidden="true" />
            </div>
          </div>
          <div className={currentNode.includes(1) ? 'overflowY h-100' : 'd-none'} style={{ maxHeight: '100%' }}>
            <ItemsList
              checkList={pendingItems && pendingItems.length > 0 && pendingItems.filter((value) => Object.keys(value).length > 0)}
              node={1}
              cardBtns={[]}
              SendBtmBtn={[]}
              position={props.position.number}
              seatOrDiscountArray={props.seat.discounts}
              setCardIndex={setCardIndex}
              cardIndex={cardIndex}
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {window.location.pathname !== '/orders' ? cartCard(cart, props.position, props.seat) : <SingleItem item={cart} renderModifier={renderModifier} {...props} />}
    </>
  );
};

Cart.propTypes = {
  cart: PropTypes.array,
  position: PropTypes.object,
  seat: PropTypes.object,
  item: PropTypes.object,
  deviceInfo: PropTypes.object,
  highlightedCartItems: PropTypes.array,
  onModifyItem: PropTypes.func,
  move: PropTypes.func,
  onRemoveItemFromCart: PropTypes.func,
  sendSingle: PropTypes.func,
  handleLongPress: PropTypes.func,
  handleRepeat: PropTypes.func,
  setVoidItemData: PropTypes.func,
  handleMangerAuthentication: PropTypes.func,
  auth: PropTypes.object,
  deleteAll: PropTypes.func,
  checkItemPresent: PropTypes.func,
  isRefill: PropTypes.bool,
  changeItemQuantity: PropTypes.func,
};

Cart.defaultProps = {
  cart: [],
  position: {},
  seat: {},
  item: {},
  deviceInfo: {},
  highlightedCartItems: [],
  onModifyItem: () => {},
  move: () => {},
  onRemoveItemFromCart: () => {},
  sendSingle: () => {},
  handleLongPress: () => {},
  handleRepeat: () => {},
  setVoidItemData: () => {},
  handleMangerAuthentication: () => {},
  auth: {},
  deleteAll: () => {},
  checkItemPresent: () => {},
  isRefill: false,
  changeItemQuantity: () => {},
};

export default Cart;
